/** Russian for `uz-b12-holatlar.ts`. */
import type { uzB12Holatlar } from "./uz-b12-holatlar";

export const ruB12Holatlar: Record<keyof typeof uzB12Holatlar, string> = {
  "hol.credits.buy": "Купить кредиты",
  "hol.credits.out": "Кредиты AI закончились · AI остановлен, диалоги перешли операторам. CRM продолжает работать.",
  "hol.credits.full": "Осталось {credits} кредитов AI. При среднем расходе хватит на {days} дн.",
  "hol.credits.short3": "Кредиты AI скоро закончатся. Владелец уведомлён.",
  "hol.credits.short1": "AI может остановиться завтра.",
  "hol.credits.thread": "Кредиты AI закончились · на этот диалог отвечаете вы.",
  "hol.channel.down": "{label}: {status}. Сообщения на этот аккаунт не принимаются.",
  "hol.channel.reconnect": "Подключить заново",
  "hol.offline.title": "Нет интернета",
  "hol.offline.text": "Написанные сообщения сохранятся и уйдут, когда связь восстановится.",
  "hol.offline.queued": "Нет интернета. Сообщение сохранено и уйдёт, как только появится связь.",
  "hol.push.title": "Разрешите уведомления",
  "hol.push.subtitle": "Сразу узнаете о новых диалогах и SLA",
  "hol.push.scope": "Только назначенные вам диалоги, передачи от AI и предупреждения SLA. В тихие часы не отправляются.",
  "hol.push.allow": "Разрешить",
  "hol.push.later": "Позже",
  "hol.push.failed": "Не удалось включить уведомления на этом устройстве.",
  "hol.push.device": "Это устройство",
  "hol.push.on": "Уведомления включены.",
  "hol.push.enable": "Включить",
  "hol.push.deniedTitle": "Уведомления выключены.",
  "hol.push.deniedText": "Разрешите Kapitan в настройках браузера или подключите Telegram в профиле.",
  "hol.push.connectTelegram": "Подключить Telegram",
  "hol.failed.count": "Не отправлено сообщений: {count}.",
  "hol.failed.reason": "{channel} не принял сообщение. Сообщения остались в очереди.",
  "hol.failed.retry": "Отправить снова",
  "hol.failed.retried": "Сообщения снова поставлены в очередь.",
  "hol.failed.retryError": "Не удалось отправить снова.",
  "hol.thread.heldBy": "Этот диалог у сотрудника {name}. Чтобы забрать его, напишите менеджеру.",
  "hol.match.title": "Этот клиент, возможно, есть и в другой карточке · {name}.",
  "hol.match.compare": "Сравнить",
  "hol.match.different": "Это другой человек",
  "hol.match.dialog": "Сравнение клиентов",
  "hol.match.reason": "Причина совпадения: {reason}",
  "hol.match.diff": "Жёлтый фон · поля, которые отличаются",
  "hol.match.name": "Имя",
  "hol.match.phone": "Телефон",
  "hol.match.trips": "Поездки",
  "hol.match.merge": "Объединить",
  "hol.match.merged": "Клиенты объединены. Отменить можно через «Разделить».",
  "hol.match.failed": "Не удалось объединить.",
  "hol.match.dismissFailed": "Не удалось сохранить.",
  "hol.match.loadFailed": "Не удалось сравнить.",
  "hol.history.running": "{label}: переносится история · {percent}%",
  "hol.thread.aiOff": "AI выключен · отвечает оператор. Черновик не показывается.",
};
